module.exports = _.camelCase;